import React from 'react';
import { useDevToolsStore } from '../../store/devToolsStore';
import ConsoleHistoryList from './ConsoleHistoryList';
import ConsoleEntryDetail from './ConsoleEntryDetail';

export default function ConsolePanel() {
  const entries = useDevToolsStore((s) => s.entries);
  const activeEntryId = useDevToolsStore((s) => s.activeEntryId);
  const selectEntry = useDevToolsStore((s) => s.selectEntry);

  const active =
    entries.find((e) => e.id === activeEntryId) || entries[0] || null;

  return (
    <div className="console-panel">
      <div className="console-panel__layout">
        <ConsoleHistoryList
          entries={entries}
          activeEntryId={active?.id}
          onSelect={selectEntry}
        />
        <ConsoleEntryDetail entry={active} />
      </div>
    </div>
  );
}
